import CommonService from "@/domain/dataTable/commonService/CommonService.js";
export default class NfeService extends CommonService {



    getNfeRecebidas(page, qntdNfe, id_empresa, range, urlFiltros) {
        let url = "nfes/empresa/" + id_empresa + "?_page=" + page + "&_pagesize=" + qntdNfe + "&_range=" + range

        urlFiltros != undefined ? url += urlFiltros : '';
        // https://app.motorfiscal.com.br/teste/nfes/empresa/5b4cc42de471d50362ddce00?_page=1&_pagesize=2&_range=semana
        return this._resource.get(url).then(success => {
            return success.body;
        },
            failed => {
                return failed;
            })
    }

    getNfeTransportados(page, qntdNfe, id_empresa, range,urlFiltros) {
        let url = "nfes/empresa/transportadora/" + id_empresa + "?_page=" + page + "&_pagesize=" + qntdNfe + "&_range=" + range;
        urlFiltros != undefined ? url += urlFiltros : '';
        return this._resource.get(url).then(success => {
            return success.body;
        },
            failed => {
                return failed
            })
    }
    getNfeEmitidas(page, qntdNfe, id_empresa, range,urlFiltros) {
        let url = "nfes/empresa/emitidas/" + id_empresa + "?_page=" + page + "&_pagesize=" + qntdNfe + "&_range=" + range;
        urlFiltros != undefined ? url += urlFiltros : '';
        return this._resource.get(url).then(success => {
            return success.body;
        },
            failed => {
                return failed
            })
    }
    sendXml(id_empresa, file) {
        
        const data = new FormData();
        data.append("file", file);

        let url = `nfes/uploadxml/${id_empresa}`;

        return this._resource.post(url, data).then(success => {

            return success;
        }, failed => {

            return failed;
        })
    }
    consultaAvulsaNota(id_empresa) {
        return this._resource.get(
            "nfes/busca/" + id_empresa
        ).then(success => {
            return success;
        },
            failed => {
                return failed;
            })
    }
    getDanfe(id_nota) {

        return this._resource.get("nfes/danfe/" + id_nota).then(
            success => {
                var data = new Uint8Array(success.body.danfe.data);
                return this.bufferToBase64(data);
            },
            failed => {
                console.log(failed);
            }
        );
    }
    getDacce(id_nota, indice) {

        return this._resource.get("nfes/cce/" + id_nota + "?_indice=" + indice).then(
            success => {
                var data = new Uint8Array(success.body.pdf.data);
                return this.bufferToBase64(data);
            },
            failed => {
                console.log(failed);
            }
        );
    }
    getXml(id_nota) {
        return this._resource.get("nfes/xml/" + id_nota).then(
            success => {
                return success.body.xml;
            },
            failed => {
                return failed;
            });
    }


    manifestar(chave, tpEvento, id_empresa, just) {
        const obj = {
            chave,
            // tpEvento: "210210"
            tpEvento: tpEvento,
            just: just
        }
        const body = JSON.stringify(obj);
        return this._resource.post("nfes/manifestacao/" + id_empresa, body).then(
            success => {
            },
            failed => {
                let message = failed.body.message.replace(/Rejeicao: /gi, "");
                return message;

            }
        );

    }

    getCTeByIdNFe(id_nota) {
        return this._resource.get("nfes/ctes/" + id_nota).then(
            success => {

                return success.body.items

            },
            failed => {
                console.log(failed);
            });
    }
}


// WEBPACK FOOTER //
// ./src/domain/notas/nfe/NfeService.js